<div style="height: 100dvh; width: 100dvw; display: flex; flex-direction: column">
  <div class="position-relative">
    <div class="header-div">
      <div class="left-side">
        <!-- <div class="menu-img"></div> -->
        <div class="heading">
          <div class="title-bg">
            <div class="title-img"></div>
          </div>
          <div class="side-title">Satsang Philanthropy USA</div>
        </div>
      </div>
      <div style="display: flex; gap:20px;">
        <div style="display: flex; margin-left: auto">
          <div style="margin-left: auto; display: flex; gap: 20px;">
            <app-user-profile-header [admin]="adminClicked?true:false"></app-user-profile-header>
            <app-theme-toggle></app-theme-toggle>
          </div>
        </div>
      </div>
    </div>
    <div class="sidebar">
      <div class="nav-items">
        @for (item of navBar; track item.webRoute; let i = $index) {
        <div class="side-tab" [class.active]="i === selectedNavIndex" (click)="selectNavItem(item, i)">
          <!-- <div
            class="side-tab-icon"
            [style.background-image]="
              'url(' +
              (i === selectedNavIndex ? item.activeImageUrl : item.imageUrl) +
              ')'
            "
          ></div> -->
          <!-- <div
            [class]="
              i === selectedNavIndex
                ? 'side-tab-title-active'
                : 'side-tab-title-inactive'
            "
          > -->
          {{ item.label }}
          <!-- </div> -->
        </div>
        }
        @if (userDetails?.showAllTransactions && !_router.url.includes('/admin')) {
        <div class="side-tab" (click)="onAdminClick()">
          Admin</div>
        }
      </div>
    </div>
  </div>
  <div class="routerBody">
    <router-outlet></router-outlet>
  </div>
</div>